(function () {
  "use strict";
  const slideInTargets = document.querySelectorAll('.c-ani-slideIn');
  const fadeInTargets = document.querySelectorAll('.c-ani-fadeIn');
  const activeClass = 'is-active'
  const startTime = 200;
  const delayTime = 200;

  slideInTargets.forEach((el, index) => {
    const delay = startTime + index * delayTime;

    setTimeout(() => {
      el.classList.add(activeClass);
    }, delay);
  });

  fadeInTargets.forEach((el, index) => {
    const delay = startTime + index * delayTime;

    setTimeout(() => {
      el.classList.add(activeClass);
    }, delay);
  });
})();